import api from '../client';

export const FeedService = {
  getFeed: (params) => api.get('/feed', { params }),
  createPost: (data) => api.post('/feed', data),
  uploadMedia: (postId, formData) => api.post(`/feed/${postId}/media`, formData, { headers: { 'Content-Type': 'multipart/form-data' } }),
  toggleLike: (postId) => api.post(`/feed/${postId}/like`),
  addComment: (postId, data) => api.post(`/feed/${postId}/comments`, data),
  deletePost: (postId) => api.delete(`/feed/${postId}`),
};